import { getCountryData, getCurrencyData, getLanguage } from '../helpers/functions';
import { UPDATE_USER_PREFERENCE } from '../helpers/types';

const INITIAL_STATE = {
  userPreference: {
    selectedLanguage: 'en',
    selectedCountry: 'UAE',
    selectedCurrency: 'AED',
  },
};

let LIBRARY_STATE = {
  ...INITIAL_STATE,
};

try {
  const languageData = getLanguage();
  const countryData = getCountryData();
  const currencyData = getCurrencyData(countryData);
  LIBRARY_STATE = {
    ...LIBRARY_STATE,
    userPreference: {
      ...INITIAL_STATE.userPreference,
      selectedLanguage: languageData[0],
      selectedCountry: 'UAE',
      selectedCurrency: currencyData[0].code,
    },
  };
} catch (err) {
  console.log(err);
}

export default (state = LIBRARY_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER_PREFERENCE:
      return {
        ...state,
        userPreference: {
          ...state.userPreference,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
